import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import Checkbox from '../../../../../../components/form/Checkbox'

const formatDateTime = (value: string | null | undefined) => {
    if (!value) {
        return {
            date: '',
        }
    }

    const date = new Date(value)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return {
        date: `${year}-${month}-${day}`,
    }
}

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    currencyData: CurrencyList[]
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
    onEmergency: (emergency: boolean) => void
    onNotDishonest: (not_dishonest: boolean) => void
}

const PurchaseBaseInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Сведения о закупке">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3 items-start justify-start ">
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                        <div className="flex flex-col w-[200px] ">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Реестровый номер
                            </label>
                            <input
                                type="text"
                                className={`form-input user-input-placeholder w-full`}
                                value={
                                    props.purchase?.registration_number
                                        ? props.purchase?.registration_number
                                        : ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                                readOnly
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата размещения
                            </label>
                            <input
                                type="date"
                                className={`form-input user-input-placeholder w-[200px]`}
                                value={
                                    props.purchase?.publication_date_time
                                        ? formatDateTime(
                                              props.purchase
                                                  .publication_date_time
                                          ).date
                                        : ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Способ закупки{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-input user-input-placeholder w-full`}
                            value={
                                props.purchase?.purchase_method_name
                                    ? props.purchase?.purchase_method_name
                                    : ''
                            }
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                            readOnly
                        />
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Наименование закупки{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full `}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.name || ''}
                            readOnly
                        />
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Закупка осуществляется вследствие аварии, иных чрезвычайных ситуаций природного или техногенного характера, непреодолимой силы, при необходимости срочного медицинского вмешательства, а также для предотвращения угрозы возникновения указанных ситуаций"
                                checked={props.purchase.emergency ?? false}
                                onChange={props.onEmergency}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Требование к отсутствию участников закупки в реестре недобросовестных поставщиков"
                                checked={props.purchase.not_dishonest ?? false}
                                onChange={props.onNotDishonest}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дополнительная информация
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.additional_info || ''}
                            readOnly
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseBaseInfo
